import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SiModalModule } from '../../../shared/components';
import { BuyerPersonasComponent } from '../../../shared/modules';
import { UserService } from '../../../core/services';

@Component({
  selector: 'app-buyer-persona-settings-modal',
  template: `
    <app-si-dialog
      header="Buyer Personas"
      [hideSaveButton]="true"
      cancelButtonText="Close"
      modalBodyClasses="flex flex-col overflow-hidden"
    >
      <ng-template appDialogBody>
        <app-buyer-personas
          class="flex flex-col h-full w-full overflow-hidden"
          [isOpsAdminOrAdmin]="isAnyAdmin$ | async"
        ></app-buyer-personas>
      </ng-template>
    </app-si-dialog>
  `,
  imports: [
    SiModalModule,
    BuyerPersonasComponent,
    AsyncPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuyerPersonaSettingsModalComponent {
  readonly isAnyAdmin$: Observable<boolean> = combineLatest([
    this.userService.listenToUserChangesByKey<boolean>('is_admin'),
    this.userService.listenToUserChangesByKey<boolean>('is_ops_admin'),
  ]).pipe(map((flags: boolean[]) => flags.some(Boolean)));

  constructor(private readonly userService: UserService) {}
}
